import { NavLink } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { IconEZHaulLogo } from '@/components/icons/Icons';
import type { NavItem } from './BottomNav';
import styles from './NavDrawer.module.css';

interface NavDrawerProps {
  /** Navigation items to render. */
  items: NavItem[];
}

/**
 * Full navigation drawer for large and xlarge screens.
 * Fixed on the inline-start side with icon + label side by side.
 * Includes app branding at the top.
 */
export function NavDrawer({ items }: NavDrawerProps) {
  return (
    <nav className={styles.navDrawer} aria-label="Main navigation">
      {/* App branding */}
      <div className={styles.brand}>
        <span className={styles.brandIcon} aria-hidden="true">
          <IconEZHaulLogo />
        </span>
        <span className={styles.brandName}>EZHaul</span>
      </div>

      {/* Navigation items */}
      <div className={styles.navList}>
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/'}
            className={({ isActive }) =>
              cn(styles.navItem, isActive && styles.active)
            }
          >
            <span className={styles.icon} aria-hidden="true">
              {item.icon}
            </span>
            <span className={styles.label}>{item.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
